module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/AB1009-0d586e7a618fdf7e3f83ff0064a5cfb5.png";